module.exports = __webpack_public_path__ + "static/media/update-profile-background.25eb5328.png";